/* eslint-disable react/prop-types */
import React from 'react';
import moment from 'moment';
import TimeIcon from '../../../../assets/icons/time.svg';

const RescheduleTag = ({ collectionTimeChanges, collectionDateTimeLocal, creationDateTime }) => (
  <div className="allocation-card-reschedule">
    <div>
      <div className="allocation-card-reschedule-times">
        {' '}
        {collectionDateTimeLocal && (
          <span>
            {moment(collectionDateTimeLocal).format('DD MMM YYYY')} {'>'}{' '}
          </span>
        )}
        {moment(collectionTimeChanges.value).format('DD MMM YYYY')}{' '}
      </div>
    </div>

    <div>
      <div className="allocation-card-reschedule-created">
        <TimeIcon style={{ width: '1em', height: '1em', verticalAlign: 'middle', marginRight: '4px', overflow: 'visible' }} /> {`Received ${moment(creationDateTime).fromNow()}`}
      </div>
    </div>
  </div>
);

const RescheduleSection = ({ booking, reschedules }) => {
  const { collectionDateTimeLocal } = booking;

  return (
    <div className="allocation-card-reschedules">
      {reschedules.map(({ collectionTimeChanges, creationDateTime }) => (
        <RescheduleTag
          key={collectionTimeChanges?.value}
          collectionTimeChanges={collectionTimeChanges}
          collectionDateTimeLocal={collectionDateTimeLocal}
          creationDateTime={creationDateTime}
        />
      ))}
    </div>
  );
};

export default RescheduleSection;
